import { useState, useEffect, useCallback } from 'react';
import { defaultAreas } from './sources.js';

const filterOption = (input, option) => {
    const key = (option?.key).toLowerCase();
    const inputChars = Array.from(input.toLowerCase());
    const keyHasAllChars = inputChars.reduce((prevResult, char) => {
        if (prevResult === undefined) {
            return true;
        }
        return prevResult && key.includes(char);
    }, true);
    return keyHasAllChars;
};
const usePhoneInput = ({ isControlled, defaultValue, value, onChange, }) => {
    if (defaultValue) {
        defaultValue.short = defaultValue.short?.toUpperCase();
    }
    if (value) {
        value.short = value.short?.toUpperCase();
    }
    const defaultArea = defaultAreas.find(area => {
        if (defaultValue) {
            return area.short === defaultValue.short;
        }
        return area.short === 'CN';
    });
    const [area, setArea] = useState(defaultArea);
    const [phone, setPhone] = useState(defaultValue?.phone);
    useEffect(() => {
        if (!isControlled)
            return;
        if (value === undefined) {
            setArea(undefined);
            setPhone(undefined);
            return;
        }
        if (value.short) {
            setArea(defaultAreas.find(area => area.short === value.short));
        }
        else {
            setArea(defaultAreas.find(area => area.phoneCode === value.code));
        }
        setPhone(value.phone);
    }, [value, isControlled]);
    const triggerChange = useCallback((phone, area) => {
        const result = {
            phone,
            code: area?.phoneCode,
            short: area?.short,
        };
        onChange?.(result);
    }, [onChange]);
    const handleAreaChange = useCallback((value) => {
        const area = defaultAreas.find(area => area.short === value);
        if (!area) {
            return;
        }
        setArea(area);
        triggerChange(phone, area);
    }, [setArea, triggerChange, phone]);
    const handlePhoneChange = useCallback((e) => {
        const currentValue = e.target.value;
        setPhone(currentValue);
        triggerChange(currentValue, area);
    }, [setPhone, area, triggerChange]);
    return { area, handleAreaChange, handlePhoneChange };
};

export { filterOption, usePhoneInput };
